import { Component } from '@angular/core';
import { ApiService } from '../../../../services/api.service';
import { Router } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-aggiungi-amministrazione-trasparente-backoffice',
  templateUrl: './aggiungi-amministrazione-trasparente-backoffice.component.html',
  styleUrl: './aggiungi-amministrazione-trasparente-backoffice.component.css'
})
export class AggiungiAmministrazioneTrasparenteBackofficeComponent {

  constructor(private apiService: ApiService, private router: Router) { }

  categorie: { categoria: string, value: string }[] = [
    { value: 'organo_direttivo', categoria: 'Organo Direttivo' },
    { value: 'contributi_pubblici', categoria: 'Contributi Pubblici' },
    { value: 'consulenze_collaborazioni', categoria: 'Consulenze e Collaborazioni' },
    { value: 'organi_amministrativi', categoria: 'Organi Amministrativi' },
  ]

  formAmministrazioneTrasparente!: FormGroup;

  filePdf: File | null = null

  ngOnInit(): void {    

    this.formAmministrazioneTrasparente = new FormGroup({
      categoria: new FormControl(null, Validators.required),
      titolo: new FormControl(null, Validators.required),
      pdf: new FormControl(null, Validators.required),      
    })
  }

  onPDFUpload(file: File | File[] | null) {
    if (!file || Array.isArray(file)) {
      this.filePdf = null;
      this.formAmministrazioneTrasparente.patchValue({ pdf: '' });
      return;
    }
    this.filePdf = file;
    this.formAmministrazioneTrasparente.patchValue({ pdf: file.name });
  };

  onRemovePDFUpload() {
    this.filePdf = null
    this.formAmministrazioneTrasparente.patchValue({ pdf: '' });
  }

  onSubmit() {

    const formData = new FormData();    
    formData.append('pdf', this.filePdf || '');
    formData.append('titolo', this.formAmministrazioneTrasparente.get('titolo')?.value);
    formData.append('categoria', this.formAmministrazioneTrasparente.get('categoria')?.value.value);    

    this.apiService.addFileAmministrazioneTrasparente(formData).subscribe({
      next: (data) => this.apiService.setFilesAmministrazioneTrasparente(),        
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
      complete: () => {
        this.router.navigate(['/backoffice/amministrazione-trasparente'])
      }
    })

  }

}
